import gql from 'graphql-tag';
import { TeamCSAWeeklySummary } from '../../PerformancePortal/CSASummaries/types';
import { TypedDocumentNode } from '@apollo/client';
import { WeeklySummary } from '@amzn/aet-summaries-kit';

export interface GetCSAWeeklySummariesVariables {
  alias: string;
  managerAlias: string;
  limit: number;
  startDate?: string;
  exclusiveStartKey?: string;
  targetLanguage?: string;
}

export interface GetCSAWeeklySummariesResponse {
  summaries: WeeklySummary[];
  count: number;
  lastEvaluatedKey: string;
  error: string | null;
}

export interface GetWeeklySummariesAppsyncResponse {
  getCSAWeeklySummaries: GetCSAWeeklySummariesResponse;
}

export const getCSAWeeklySummaries: TypedDocumentNode<
  GetWeeklySummariesAppsyncResponse,
  GetCSAWeeklySummariesVariables
> = gql`
  query getCSAWeeklySummaries(
    $alias: String!
    $managerAlias: String
    $limit: Int
    $startDate: String
    $exclusiveStartKey: String
    $targetLanguage: String
  ) {
    getCSAWeeklySummaries(
      alias: $alias
      managerAlias: $managerAlias
      limit: $limit
      startDate: $startDate
      exclusiveStartKey: $exclusiveStartKey
      targetLanguage: $targetLanguage
    ) {
      summaries {
        uuid
        alias
        date
        summary
        translatedSummary
        translationState
        feedbackProviders
        contact_count
        isDeleted
        deletedReason
        marketplaces
        stats {
          Compliance {
            FalsePromise {
              total
              yes_count
              yes_percentage
            }
          }
          Efficiency {
            meets_bar
            meets_bar_percentage
            total
            red_flag
            needs_improvement_percentage
            needs_improvement
            red_flag_percentage
          }
          Empathy {
            meets_bar
            meets_bar_percentage
            total
            red_flag
            needs_improvement_percentage
            needs_improvement
            red_flag_percentage
          }
          Helpfulness {
            meets_bar
            meets_bar_percentage
            total
            red_flag
            needs_improvement_percentage
            needs_improvement
            red_flag_percentage
          }
          Knowledgability {
            meets_bar
            meets_bar_percentage
            total
            red_flag
            needs_improvement_percentage
            needs_improvement
            red_flag_percentage
          }
          OverallExperience {
            meets_bar
            meets_bar_percentage
            total
            red_flag
            needs_improvement_percentage
            needs_improvement
            red_flag_percentage
          }
          Politeness {
            meets_bar
            meets_bar_percentage
            total
            red_flag
            needs_improvement_percentage
            needs_improvement
            red_flag_percentage
          }
          Understandability {
            meets_bar
            meets_bar_percentage
            total
            red_flag
            needs_improvement_percentage
            needs_improvement
            red_flag_percentage
          }
        }
      }
      count
      lastEvaluatedKey
      error
    }
  }
`;

export interface GetTeamWeeklySummariesVariables {
  aliases: string[];
  managerAlias: string;
  targetLanguage?: string;
}

export interface GetTeamWeeklySummariesResponse {
  getTeamLatestSummaries: {
    results: TeamCSAWeeklySummary[];
    count: number;
    error: string;
  };
}

export const getTeamWeeklySummaries: TypedDocumentNode<
  GetTeamWeeklySummariesResponse,
  GetTeamWeeklySummariesVariables
> = gql`
  query getTeamLatestSummaries(
    $aliases: [String!]!
    $managerAlias: String
    $targetLanguage: String
  ) {
    getTeamLatestSummaries(
      aliases: $aliases
      managerAlias: $managerAlias
      targetLanguage: $targetLanguage
    ) {
      results {
        alias
        summary {
          uuid
          alias
          date
          summary
          translatedSummary
          translationState
          feedbackProviders
          contact_count
          isDeleted
          deletedReason
          marketplaces
          stats {
            Compliance {
              FalsePromise {
                total
                yes_count
                yes_percentage
              }
            }
            Efficiency {
              meets_bar
              meets_bar_percentage
              total
              red_flag
              needs_improvement_percentage
              needs_improvement
              red_flag_percentage
            }
            Empathy {
              meets_bar
              meets_bar_percentage
              total
              red_flag
              needs_improvement_percentage
              needs_improvement
              red_flag_percentage
            }
            Helpfulness {
              meets_bar
              meets_bar_percentage
              total
              red_flag
              needs_improvement_percentage
              needs_improvement
              red_flag_percentage
            }
            Knowledgability {
              meets_bar
              meets_bar_percentage
              total
              red_flag
              needs_improvement_percentage
              needs_improvement
              red_flag_percentage
            }
            OverallExperience {
              meets_bar
              meets_bar_percentage
              total
              red_flag
              needs_improvement_percentage
              needs_improvement
              red_flag_percentage
            }
            Politeness {
              meets_bar
              meets_bar_percentage
              total
              red_flag
              needs_improvement_percentage
              needs_improvement
              red_flag_percentage
            }
            Understandability {
              meets_bar
              meets_bar_percentage
              total
              red_flag
              needs_improvement_percentage
              needs_improvement
              red_flag_percentage
            }
          }
        }
        hasHadSummary
      }
      count
      error
    }
  }
`;
